export default class tab {
    constructor(scroll,param,hash){

        this.$trigger;
        this.$select;
        this.$selectText;
        this.$subSelect;
        this.$subContent;
        this.$subSelectText;
        this.$content;

        this.status = {
            current : 0,
            prevCurrent : 0,
            subCurrent : [],
            subPrevCurrent : [],
            text : '',
            flg : false,
            url : location.href,
            hash : hash
        }
        this.param = param;

        this.scroll = scroll;

        if(hash){
            hash = hash.replace( /#lineup/g , "" );
            this.status.hash = [];
            if ( hash.indexOf('-') != -1) { //子
                hash = hash.split('-');
                for ( let i = 0; i < hash.length; i++ ) {
                    this.status.hash[i] = Number(hash[i]);
                }
            }else{ //親
                this.status.hash[0] = Number(hash);
            }
        }

    }
    init(){

        this.$trigger = document.querySelectorAll(".js__tab-trigger");
        this.$select = document.querySelector(".js__tab-select");
        this.$selectText = document.querySelector(".js__tab-select-text");
        this.$subSelect = document.querySelectorAll(".js__sub-tab-select");
        this.$subContent = document.querySelectorAll(".js__sub-tab-content");
        this.$subSelectText = document.querySelectorAll(".js__sub-tab-select-text");
        this.$content = document.querySelectorAll(".js__tab-content");

        for(let i in this.$trigger){
            if(this.$trigger[i].nodeType!==1) break;
            TweenMax.set(this.$content[i], {
                opacity: 0,
                display: 'none',
            });
            this.$trigger[i].addEventListener("click",(e)=>{
                if(!this.status.flg && !this.$trigger[i].classList.contains('is-current')){
                    this.status.flg = true;
                    this.status.current = i;
                    this.change();
                }
            });
        }
        this.$content[0].classList.add('is-current');
        TweenMax.set(this.$content[0], {
            opacity: 1,
            display: 'block',
            onComplete: () => {
                this.scroll.resize(window.innerWidth,window.innerHeight);
            }
        });
        this.$select.addEventListener("change",(e)=>{
            this.status.flg = true;
            this.status.current = e.target.selectedIndex;
            this.change();
        });
        for(let i in this.$subSelect) {
            if(this.$subSelect[i].nodeType!==1) break;
            this.status.subCurrent[i] = 0;
            this.status.subPrevCurrent[i] = 0;
            this.$subSelect[i].querySelector('select').addEventListener("change", (e) => {
                this.status.flg = true;
                this.status.subCurrent[i] = e.target.selectedIndex;
                this.subChange(i);
            });
        }

        this.resize();

        // 遷移からのタブ切替え
        if(this.status.hash){
            this.status.current = this.status.hash[0] - 1;
            if(this.status.current !== 0 && this.status.hash.length > 1){
                this.status.flg = true;
                this.change();
            }else if(this.status.current !== 0 && this.$subContent[0]){
                this.status.flg = true;
                this.change();
            }else if(this.status.current !== 0 && this.status.hash.length === 1 && this.param.displayType === 'sp'){
                this.status.flg = true;
                this.change();
            }
            if(this.status.hash.length === 1 && this.param.displayType !== 'sp' && this.status.url.indexOf('/cat/') != -1){
                let rect = this.$content[this.status.current].getBoundingClientRect();
                let _position = rect.top + window.pageYOffset - 150;
                this.scroll.to(_position);
            }
            setTimeout(()=>{
                if(this.status.hash.length > 1){
                    if(this.param.displayType !== 'sp'){ //pc
                        let rect = this.$subContent[this.status.hash[0] - 1].children[this.status.hash[1] - 1].getBoundingClientRect();
                        let _position = rect.top + window.pageYOffset - 150;
                        this.scroll.to(_position);
                    }else{ //sp
                        if(this.status.hash[1] - 1 !== 0) {
                            this.status.subCurrent[this.status.hash[0] - 1] = this.status.hash[1] - 1;
                            this.subChange(this.status.hash[0] - 1);
                        }else{
                            this.status.flg = false;
                        }
                    }
                    this.$subSelect[this.status.hash[0] - 1].querySelector('select').selectedIndex = this.status.hash[1] - 1;
                }
            },15e2);
        }

    }
    change(){

        this.status.text = this.$select[this.status.current].value;
        this.$selectText.innerHTML = this.status.text;
        this.$select.selectedIndex = this.status.current;

        TweenMax.set(this.$content[this.status.current], {
            display: 'block',
        });
        TweenMax.to(this.$content[this.status.prevCurrent], 0.2, {
            opacity: 0,
            onStart: () => {
                if(this.$trigger[0]) this.$trigger[this.status.prevCurrent].classList.remove("is-current");
                this.$content[this.status.prevCurrent].classList.remove("is-current");
                if(this.$trigger[0]) this.$trigger[this.status.current].classList.add("is-current");
                this.$content[this.status.current].classList.add("is-current");
                TweenMax.fromTo(this.$content[this.status.current],0.6,{
                    opacity: 0,
                },{
                    opacity: 1,
                    onComplete: () => {
                        this.status.flg = false;
                        TweenMax.set(this.$content[this.status.prevCurrent], {
                            display: 'none',
                        });
                        this.status.prevCurrent = Number(this.status.current);
                        this.scroll.resize(window.innerWidth,window.innerHeight);
                    }
                });
            }
        });

    }
    subChange(_index){

        this.status.text = this.$subSelect[_index].querySelector('select')[this.status.subCurrent[_index]].value;
        this.$subSelectText[_index].innerHTML = this.status.text;

        TweenMax.set(this.$subContent[_index].children[this.status.subCurrent[_index]], {
            display: 'block',
        });
        TweenMax.to(this.$subContent[_index].children[this.status.subPrevCurrent[_index]],0.2,{
            opacity: 0,
            onStart:()=>{
                this.$subContent[_index].children[this.status.subPrevCurrent[_index]].classList.remove("is-current");
                this.$subContent[_index].children[this.status.subCurrent[_index]].classList.add("is-current");
                TweenMax.fromTo(this.$subContent[_index].children[this.status.subCurrent[_index]],0.6,{
                    opacity: 0,
                },{
                    opacity: 1,
                    onComplete: () => {
                        this.status.flg = false;
                        TweenMax.set(this.$subContent[_index].children[this.status.subPrevCurrent[_index]], {
                            display: 'none',
                        });
                        this.status.subPrevCurrent[_index] = this.status.subCurrent[_index];
                        this.scroll.resize(window.innerWidth,window.innerHeight);
                    }
                });
            }
        });

    }
    resize(_displayType){

        for ( let i = 0; i < this.$subContent.length; i++ ) {
            for ( let j = 0; j < this.$subContent[i].children.length; j++ ) {
                if(_displayType === 'sp') {
                    TweenMax.set(this.$subContent[i].children[j], {
                        opacity: 0,
                        display: 'none',
                    });
                }else{
                    TweenMax.set(this.$subContent[i].children[j], {
                        opacity: 1,
                        display: 'block',
                    });
                }
            }
            TweenMax.set(this.$subContent[i].children[0], {
                opacity: 1,
                display: 'block'
            });
            this.$subContent[i].children[0].classList.add('is-current');
        }

    }
}
